export const initialState = {
  placeItems: [],
  notification: '',
  pageCount: 1,
};
